import { formatUserFacingError } from '@/lib/errors'
import { useEffect, useState } from 'react'
import { getAllProducts } from '../services/shop.service'
import type { ShopProductDocument } from '../types'

export function useShopProducts() {
  const [products, setProducts] = useState<ShopProductDocument[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    getAllProducts()
      .then(setProducts)
      .catch((err) => setError(formatUserFacingError(err, 'Failed to load products.')))
      .finally(() => setLoading(false))
  }, [])

  return { products, loading, error }
}
